import { useEffect, useState } from "react";
import { HomeLayout } from "../layouts/HomeLayout";
import LogoMark5 from "../assets/image/AgileApVector-1.png";
import LogoMark6 from "../assets/image/AgileAPVector-2.png";
import InvoiceNowLGLogo from "../assets/image/InvoiceNow_Logo.png";
import InvoiceNowBlackLogo from "../assets/image/InvoiceNow_Black.png";
import dashboardImg from "../assets/image/Dashboard-2.png";
import MetatagHelmet from "../components/MetatagHelmet";
import { useNavigate, useParams } from "react-router-dom";
import gstInvoiceNow from "../assets/image/gst-invoicenow.png";
import fastBillingInvoiceNow from "../assets/image/fast-billing.png";
import cleanDataInvoiceNow from "../assets/image/clean-data.png";
import automatedProcessInvoiceNow from "../assets/image/automated-processing.png";
import futureProofingInvoiceNow from "../assets/image/future-proofing.png";
import { FaCheck } from "react-icons/fa";
import { Helper } from "../utils/helpers";
import Content from "../assets/image/Content.png";
import * as React from "react";

const freqQAndAList = [
  {
    question: "How do I sign up for Peppol (InvoiceNow) e-invoicing? ",
    answer: "Simply approach us at sales@agileap.com or info@activants.com",
    index: 0,
  },
  {
    question: "Do I need to register my company for a Peppol ID? If yes, how can I do it? ",
    answer:
      "Certainly, your company must be registered to send and receive Peppol e-invoices. Registration will be handled by Activants (Tickstar Access Point) upon your sign-up. ",
    index: 1,
  },
  {
    question:
      "Given that InvoiceNow utilises the European-based Peppol network, can it still function effectively in Singapore? ",
    answer:
      "Indeed, there is a distinction. Online invoicing typically involves sending a scanned copy of the invoice or a PDF file to the recipient via email. This method relies on manual data entry, which is inherently susceptible to human error. <br><br> On the other hand, InvoiceNow represents a form of e-invoicing wherein invoices are digitally generated within a supplier's financial system. They are then electronically transmitted through the network to the recipient's financial system, where they are processed automatically, without human intervention. This ensures a more secure, accurate, and reliable transmission of data. ",
    index: 2,
  },
  {
    question: "What exactly does e-invoicing entail, and is it secure? ",
    answer:
      "E-invoicing is an automated procedure enabling companies in Singapore to electronically create, send, and receive invoices via specialised software or solutions. This eliminates the necessity for printing and posting traditional paper invoices, thereby streamlining the entire payment process.  <br><br> Conducting e-invoicing transactions on the Peppol network directly links sellers and purchasers. Additionally, e-invoices are transmitted using electronic standards and delivered directly to your Peppol-registered customers in the network, employing industry-standard security protocols like SSL encryption to safeguard personal details from interception by third parties during transmission. ",
    index: 3,
  },
  {
    question: "Can IRAS assess my e-invoices? ",
    answer:
      "No, according to current legal regulations, IRAS cannot access invoices. Nevertheless, you are still required to adhere to any relevant tax regulations stipulated by IRAS. ",
    index: 4,
  },
  {
    question: "Is e-invoicing compulsory in Singapore?  ",
    answer:
      "Although e-invoicing is not obligatory in Singapore, the nation has taken numerous measures to encourage organisations to participate in the Peppol network via the country's dedicated InvoiceNow platform. ",
    index: 5,
  },
];

export default function Faq() {
  const { country } = useParams();
  const [clickedIndex, setClickedIndex] = useState(0);
  const navigate = useNavigate();
  const [appUrl, setAppUrl] = useState(process.env.REACT_APP_URL ? process.env.REACT_APP_URL : "");
  const [mainUrl, setMainUrl] = useState(process.env.REACT_APP_IMAGE_URL ? process.env.REACT_APP_IMAGE_URL : "https://agileap.com/");
  const [autoloadQuestion, setAutoloadQuestion] = useState<string>("");
  useEffect(() => {
    const queryParam = window.location.pathname.split("/").pop();
    if (queryParam && queryParam.toLowerCase().includes("forget")) {
      setAutoloadQuestion("q-11");
    }else if (queryParam && queryParam.toLowerCase().match(/^q-\d+$/)) { //if queryParam is like q-1, q-2, etc.
      setAutoloadQuestion(queryParam);
    }
  }, []);

  const [questionQuery, setQuestionQuery] = useState<any>({});
  const [changes, setChanges] = useState<any>();
  const handleChangeQuestion = (question: string) => {
    let questionQueries = questionQuery;
    if (questionQueries[question] === undefined) {
      questionQueries[question] = true;
    } else {
      questionQueries[question] = !questionQueries[question];
    }
    setQuestionQuery(questionQueries);
    setChanges(!changes);
  };

  useEffect(() => {
    if (autoloadQuestion) {
      handleChangeQuestion(autoloadQuestion);
    }
  }, [autoloadQuestion]);

  const mainContentDesktop = (
    <>
      <MetatagHelmet
        title="InvoiceNow | AgileAP - Automate Accounts Payable and Receivables"
        description="AgileAP is an IMDA accredited solution provider for InvoiceNow. With AgileAP, e-invoices, e-purchase orders and e-credit notes can be exchanged seamlessly and nearly instantaneously to any buyers and suppliers through the InvoiceNow network."
        url={window.location.href}
      />

      <div className="flex flex-col w-full items-center lg:gap-y-16 gap-y-8">
        <section className="flex flex-col w-full py-8 lg:pl-24 lg:px-24 px-8 gap-y-6 bg-white">
          <div className="flex flex-col justify-center gap-y-4">
            <label className="lg:text-3xl text-xl font-black text-black text-center">Frequently Ask Questions</label>
            <div className={`text-center space-y-1`}>
              <p>If there are questions you want to ask, we will answer all your questions.</p>
            </div>
          </div>
          <div className={`w-full flex flex-col py-8 justify-center px-8 md:px-24 lg:px-24 `}>
            <div className={`border-b border-gray-300 py-6 flex flex-col gap-y-8`}>
              <div
                className={`flex justify-between items-center gap-x-8 cursor-pointer`}
                onClick={() => handleChangeQuestion("q-11")}
              >
                <label
                  className={`text-base md:text-lg cursor-pointer ${
                    questionQuery["q-11"] === true ? "text-primary" : "text-secondary"
                  }`}
                >
                  Forgot login credentials?
                </label>
                {questionQuery["q-11"] === true ? (
                  <span className={`text-primary text-2xl md:text-xl cursor-pointer`}>&#8722;</span>
                ) : (
                  <span className={`text-black text-2xl md:text-3xl cursor-pointer`}>&#43;</span>
                )}
              </div>
              <p className={`text-secondary ${questionQuery["q-11"] === true ? "" : "hidden"}`}>
                <ul className="list-disc px-4 space-y-2">
                  <li>
                    Prepare your company details such as company name, registered email address, and company registration number.
                  </li>
                  <li>
                    Contact AgileAP support team via email (<a href="mailto:support@agileap.com" className={`text-deepBlue underline`}>support@agileap.com</a>) or WhatsApp (<a href="https://wa.me/6580880170" target="_blank" className={`text-deepBlue underline`}>+65 8088 0170</a>) for assistance.
                  </li>
                </ul>
              </p>
            </div>
            <div className={`border-b border-gray-300 py-6 flex flex-col gap-y-8`}>
              <div
                className={`flex justify-between items-center gap-x-8 cursor-pointer`}
                onClick={() => handleChangeQuestion("q-1")}
              >
                <label
                  className={`text-base md:text-lg cursor-pointer ${
                    questionQuery["q-1"] === true ? "text-primary" : "text-secondary"
                  }`}
                >
                  What is InvoiceNow?
                </label>
                {questionQuery["q-1"] === true ? (
                  <span className={`text-primary text-2xl md:text-xl cursor-pointer`}>&#8722;</span>
                ) : (
                  <span className={`text-black text-2xl md:text-3xl cursor-pointer`}>&#43;</span>
                )}
              </div>
              <p className={`text-secondary ${questionQuery["q-1"] === true ? "" : "hidden"}`}>
                InvoiceNow is Singapore’s <b>nationwide e-invoicing framework</b>, built on the <b>Peppol network</b>,
                enabling businesses to <b>send and receive invoices digitally between accounting systems</b>. It
                eliminates manual data entry, reduces errors, and improves payment efficiency.
              </p>
            </div>
            <div className={`border-b border-gray-300 py-6 flex flex-col gap-y-8 `}>
              <div
                className={`flex justify-between items-center gap-x-8 cursor-pointer`}
                onClick={() => handleChangeQuestion("q-2")}
              >
                <label
                  className={`text-base md:text-lg cursor-pointer ${
                    questionQuery["q-2"] === true ? "text-primary" : "text-secondary"
                  }`}
                >
                  What is the GST InvoiceNow Requirement?
                </label>
                {questionQuery["q-2"] === true ? (
                  <span className={`text-primary text-2xl md:text-xl cursor-pointer`}>&#8722;</span>
                ) : (
                  <span className={`text-black text-2xl md:text-3xl cursor-pointer`}>&#43;</span>
                )}
              </div>
              <p className={`text-secondary ${questionQuery["q-2"] === true ? "" : "hidden"}`}>
                On <b>April 15, 2024</b>, the <b>Inland Revenue Authority of Singapore (IRAS)</b> announced a phased
                adoption of <b>InvoiceNow for GST-registered businesses</b>. This requires businesses to{" "}
                <b>transmit invoice data to IRAS via the InvoiceNow network</b> using InvoiceNow-Ready Solutions.{" "}
              </p>
            </div>
            <div className={`border-b border-gray-300 py-6 flex flex-col gap-y-8`}>
              <div
                className={`flex justify-between items-center gap-x-8 cursor-pointer`}
                onClick={() => handleChangeQuestion("q-3")}
              >
                <label
                  className={`text-base md:text-lg cursor-pointer ${
                    questionQuery["q-3"] === true ? "text-primary" : "text-secondary"
                  }`}
                >
                  When does the GST InvoiceNow Requirement take effect?
                </label>
                {questionQuery["q-3"] === true ? (
                  <span className={`text-primary text-2xl md:text-xl cursor-pointer`}>&#8722;</span>
                ) : (
                  <span className={`text-black text-2xl md:text-3xl cursor-pointer`}>&#43;</span>
                )}
              </div>
              <p className={`text-secondary ${questionQuery["q-3"] === true ? "" : "hidden"}`}>
                <ul className="list-disc space-y-2 px-4">
                  <li>
                    <b>November 1, 2025</b> – Newly incorporated companies that voluntarily register for GST must use
                    InvoiceNow.{" "}
                  </li>
                  <li>
                    <b>April 1, 2026</b> – All new voluntary GST-registrants must comply.{" "}
                  </li>
                  <li>
                    <b>May 1, 2025</b> – Soft launch for early adopters (existing GST-registered businesses or
                    businesses applying for GST registration after May 1, 2025).
                  </li>
                  <li>
                    Future phases will <b>extend the requirement to all GST-registered businesses</b>.
                  </li>
                </ul>
              </p>
            </div>
            <div className={`border-b border-gray-300 py-6 flex flex-col gap-y-8`}>
              <div
                className={`flex justify-between items-center gap-x-8 cursor-pointer`}
                onClick={() => handleChangeQuestion("q-4")}
              >
                <label
                  className={`text-base md:text-lg cursor-pointer ${
                    questionQuery["q-4"] === true ? "text-primary" : "text-secondary"
                  }`}
                >
                  {" "}
                  Why should businesses adopt InvoiceNow?
                </label>
                {questionQuery["q-4"] === true ? (
                  <span className={`text-primary text-2xl md:text-xl cursor-pointer`}>&#8722;</span>
                ) : (
                  <span className={`text-black text-2xl md:text-3xl cursor-pointer`}>&#43;</span>
                )}
              </div>
              <p className={`text-secondary ${questionQuery["q-4"] === true ? "" : "hidden"}`}>
                <ul className="list-disc space-y-2 px-4">
                  <li>Faster Payments – Digital invoices speed up processing. </li>
                  <li>Reduced Errors – Eliminates manual data entry. </li>
                  <li>Regulatory Compliance – Meets IRAS tax requirements. </li>
                  <li>Cost Savings – Lowers administrative expenses. </li>
                  <li>Secure Transactions – Uses Peppol-certified access points. </li>
                </ul>
              </p>
            </div>
            <div className={`border-b border-gray-300 py-6 flex flex-col gap-y-8`}>
              <div
                className={`flex justify-between items-center gap-x-8 cursor-pointer`}
                onClick={() => handleChangeQuestion("q-5")}
              >
                <label
                  className={`text-base md:text-lg cursor-pointer ${
                    questionQuery["q-5"] === true ? "text-primary" : "text-secondary"
                  }`}
                >
                  Where can businesses get support for InvoiceNow adoption?
                </label>
                {questionQuery["q-5"] === true ? (
                  <span className={`text-primary text-2xl md:text-xl cursor-pointer`}>&#8722;</span>
                ) : (
                  <span className={`text-black text-2xl md:text-3xl cursor-pointer`}>&#43;</span>
                )}
              </div>
              <p className={`text-secondary ${questionQuery["q-5"] === true ? "" : "hidden"}`}>
                You can reach out to our sales team at <b>sales@agileap.com</b> or message us on WhatsApp at{" "}
                <b>+65 8088 0170</b> to discuss how we can support your business.
              </p>
            </div>
            <div
              className={`border-b border-gray-300 py-6 flex flex-col gap-y-8 cursor-pointer`}
              onClick={() => handleChangeQuestion("q-6")}
            >
              <div className={`flex justify-between items-center gap-x-8`}>
                <label
                  className={`text-base md:text-lg cursor-pointer ${
                    questionQuery["q-6"] === true ? "text-primary" : "text-secondary"
                  }`}
                >
                  What is AgileAP?
                </label>
                {questionQuery["q-6"] === true ? (
                  <span className={`text-primary text-2xl md:text-xl cursor-pointer`}>&#8722;</span>
                ) : (
                  <span className={`text-black text-2xl md:text-3xl cursor-pointer`}>&#43;</span>
                )}
              </div>
              <p className={`text-secondary ${questionQuery["q-6"] === true ? "" : "hidden"}`}>
                AgileAP is an <b>InvoiceNow-Ready Solution Provider (IRSP)</b> and{" "}
                <b>accounts payable and receivable automation solution</b> that helps businesses{" "}
                <b>integrate with InvoiceNow</b> effortlessly. It enables{" "}
                <b>seamless e-invoicing, tax compliance, and cross-border transactions</b> while ensuring faster invoice
                processing.
              </p>
            </div>
            <div
              className={`border-b border-gray-300 py-6 flex flex-col gap-y-8 cursor-pointer`}
              onClick={() => handleChangeQuestion("q-7")}
            >
              <div className={`flex justify-between items-center gap-x-8`}>
                <label
                  className={`text-base md:text-lg cursor-pointer ${
                    questionQuery["q-7"] === true ? "text-primary" : "text-secondary"
                  }`}
                >
                  How can businesses get onboarded to InvoiceNow with AgileAP?
                </label>
                {questionQuery["q-7"] === true ? (
                  <span className={`text-primary text-2xl md:text-xl cursor-pointer`}>&#8722;</span>
                ) : (
                  <span className={`text-black text-2xl md:text-3xl cursor-pointer`}>&#43;</span>
                )}
              </div>
              <p className={`text-secondary ${questionQuery["q-7"] === true ? "" : "hidden"}`}>
                <ul className={`space-y-2`}>
                  <li>
                    <span className={`flex gap-2 font-bold`}>
                      <FaCheck className={`text-primary text-base md:text-lg`} /> Step 1: Register for InvoiceNow
                    </span>
                    <ul className="list-disc space-y-2 px-8 py-4">
                      <li>Check if your accounting software is InvoiceNow-ready. </li>
                      <li>If not, onboard with an InvoiceNow Ready service provider certified like AgileAP. </li>
                    </ul>
                  </li>
                  <li>
                    <span className={`flex gap-2 font-bold`}>
                      <FaCheck className={`text-primary text-base md:text-lg`} /> Step 2: Set Up AgileAP
                    </span>
                    <ul className="list-disc space-y-2 px-8 py-4">
                      <li>Sign up with AgileAP for seamless InvoiceNow integration.</li>
                      <li>Configure your system to send and receive e-invoices via the InvoiceNow network. </li>
                      <li>Ensure compliance with IRAS GST InvoiceNow requirements. </li>
                    </ul>
                  </li>
                  <li>
                    <span className={`flex gap-2 font-bold`}>
                      <FaCheck className={`text-primary text-base md:text-lg`} /> Step 3: Start Transacting
                    </span>
                    <ul className="list-disc space-y-2 px-8 py-4">
                      <li>Use AgileAP to send, receive, and track invoices digitally. </li>
                      <li>Ensure tax compliance by transmitting invoice data to IRAS automatically. </li>
                    </ul>
                  </li>
                </ul>
              </p>
            </div>
            <div className={`border-b border-gray-300 py-6 flex flex-col gap-y-8`}>
              <div
                className={`flex justify-between items-center gap-x-8 cursor-pointer`}
                onClick={() => handleChangeQuestion("q-8")}
              >
                <label
                  className={`text-base md:text-lg cursor-pointer ${
                    questionQuery["q-8"] === true ? "text-primary" : "text-secondary"
                  }`}
                >
                  {" "}
                  How do businesses send and receive documents using AgileAP?{" "}
                </label>
                {questionQuery["q-8"] === true ? (
                  <span className={`text-primary text-2xl md:text-xl cursor-pointer`}>&#8722;</span>
                ) : (
                  <span className={`text-black text-2xl md:text-3xl cursor-pointer`}>&#43;</span>
                )}
              </div>
              <p className={`text-secondary ${questionQuery["q-8"] === true ? "" : "hidden"}`}>
                <ul className={`space-y-2`}>
                  <li>
                    <span className={`flex gap-2 font-bold`}>
                      <FaCheck className={`text-primary text-base md:text-lg`} /> Sending Invoices via AgileAP
                    </span>
                    <ul className="list-disc space-y-2 px-8 py-4">
                      <li>Enter the invoice details in AgileAP. </li>
                      <li>
                        AgileAP automatically formats and transmits the invoice via the InvoiceNow (Peppol) network.{" "}
                      </li>
                      <li>The invoice is sent directly to the buyer’s system. </li>
                    </ul>
                  </li>
                  <li>
                    <span className={`flex gap-2 font-bold`}>
                      <FaCheck className={`text-primary text-base md:text-lg`} />
                      Receiving Invoices via AgileAP
                    </span>
                    <ul className="list-disc space-y-2 px-8 py-4">
                      <li>AgileAP captures incoming invoices from suppliers via Peppol. </li>
                      <li>The system validates and processes the invoice. </li>
                      <li>The invoice is stored in your system for payment and tax reporting. </li>
                    </ul>
                  </li>
                </ul>
              </p>
            </div>
            <div className={`border-b border-gray-300 py-6 flex flex-col gap-y-8`}>
              <div
                className={`flex justify-between items-center gap-x-8 cursor-pointer`}
                onClick={() => handleChangeQuestion("q-9")}
              >
                <label
                  className={`text-base md:text-lg cursor-pointer ${
                    questionQuery["q-9"] === true ? "text-primary" : "text-secondary"
                  }`}
                >
                  How does AgileAP help businesses comply with the GST InvoiceNow Requirement?{" "}
                </label>
                {questionQuery["q-9"] === true ? (
                  <span className={`text-primary text-2xl md:text-xl cursor-pointer`}>&#8722;</span>
                ) : (
                  <span className={`text-black text-2xl md:text-3xl cursor-pointer`}>&#43;</span>
                )}
              </div>
              <p className={`text-secondary ${questionQuery["q-9"] === true ? "" : "hidden"}`}>
                <p>AgileAP ensures compliance by:</p>
                <ul className="list-item space-y-2 py-4">
                  <li>
                    <span className={`flex gap-2 items-center`}>
                      <FaCheck className={`text-black text-base`} />
                      Transmitting invoice data to IRAS automatically.
                    </span>
                  </li>
                  <li>
                    <span className={`flex gap-2 items-center`}>
                      <FaCheck className={`text-black text-base`} />
                      Ensuring IRAS tax compliance through real-time validation.
                    </span>
                  </li>
                  <li>
                    <span className={`flex gap-2 items-center`}>
                      <FaCheck className={`text-black text-base`} />
                      Providing a secure and seamless e-invoicing solution.
                    </span>
                  </li>
                </ul>
              </p>
            </div>
            <div className={`border-b border-gray-300 py-6 flex flex-col gap-y-8`}>
              <div
                className={`flex justify-between items-center gap-x-8 cursor-pointer`}
                onClick={() => handleChangeQuestion("q-10")}
              >
                <label
                  className={`text-base md:text-lg cursor-pointer ${
                    questionQuery["q-10"] === true ? "text-primary" : "text-secondary"
                  }`}
                >
                  How can businesses sign up for AgileAP?
                </label>
                {questionQuery["q-10"] === true ? (
                  <span className={`text-primary text-2xl md:text-xl cursor-pointer`}>&#8722;</span>
                ) : (
                  <span className={`text-black text-2xl md:text-3xl cursor-pointer`}>&#43;</span>
                )}
              </div>
              <p className={`text-secondary ${questionQuery["q-10"] === true ? "" : "hidden"}`}>
                <ul className="list-disc px-4 space-y-2">
                  <li>
                    Visit{" "}
                    <a href={"https://agileap.com"} className={`text-deepBlue underline`}>
                      www.agileap.com
                    </a>{" "}
                    and register for an InvoiceNow-ready solution.
                  </li>
                  <li>
                    Contact AgileAP for a <b>free demo and consultation</b>.
                  </li>
                </ul>
              </p>
            </div>
          </div>
        </section>
      </div>
    </>
  );

  return <HomeLayout showHeader={true} showFooter={true} mainContent={mainContentDesktop} currentPage="Faq" />;
}
